
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { email, required } from 'vuelidate/lib/validators'

@Component({
  validations () {
    // @ts-ignore
    return this.validationRules()
  }
})

export default class extends Vue {
  @Prop({ default: '' }) type: string

  validationRules () {
    return {
      formData: {
        name: { required },
        phone: { required },
        email: { email, required },
        isInOrganization: { required: ['artist', 'artCritic', 'curator'].includes(this.type) && required }, // artist, critic, curator
        linkPhoto: { required: ['artCritic', 'artist', 'curator'].includes(this.type) && required }, // artist, critic, curator
        linkWork: { required: this.type === 'artist' && required }, // artist
        linkPublish: { required: ['artCritic', 'curator'].includes(this.type) && required }, // critic, curator
        nameGallery: { required: this.type === 'gallery' && required }, // gallery
        linkLogotype: { required: ['gallery', 'showroom', 'business'].includes(this.type) && required }, // gallery, showroom, business
        linkSite: { required: ['gallery', 'showroom', 'business'].includes(this.type) && required }, // gallery, showroom, business
        nameShowRoom: { required: this.type === 'showroom' && required }, // showroom
        nameCompany: { required: this.type === 'business' && required } // business
      }
    }
  }

  isDisabledBtn = false
  isSuccess = false
  isError = false

  formData = {
    name: '',
    phone: '',
    email: '',
    isInOrganization: '',
    linkPhoto: '',
    linkWork: '',
    linkPublish: '',
    nameGallery: '',
    linkLogotype: '',
    linkSite: '',
    nameShowRoom: '',
    nameCompany: ''
  }

  endpoint = {
    artist: '/api/synergy/register/artist',
    artCritic: '/api/synergy/register/art-critic',
    gallery: '/api/synergy/register/gallery',
    showroom: '/api/synergy/register/showroom',
    curator: '/api/synergy/register/curator',
    business: '/api/synergy/register/business'
  }

  onSubmit () {
    this.$v.$touch()
    if (this.$v.$error) {
      return
    }

    this.isError = false
    this.isDisabledBtn = true
    this.$axios.post(process.env.API_ENDPOINT + this.endpoint[this.type], this.formData)
      .then(() => {
        this.isSuccess = true
      }).catch(() => {
        this.isError = true
      }).finally(() => {
        this.isDisabledBtn = false
      })
  }
}
